export default __webpack_public_path__ + "8b72f71ed3a9759e7c534bdd73675962.svg";